import type { ReactElement } from 'react';

import { IconCircleTick } from '@xing-com/icons';
import { scale110 } from '@xing-com/tokens';

import * as Styled from './card-membership-status.styled';

export type CardMembershipStatusProps = {
  children: string;
};

export const CardMembershipStatus = ({
  children,
}: CardMembershipStatusProps): ReactElement => (
  <Styled.Container>
    <IconCircleTick aria-hidden="true" height={scale110} width={scale110} />
    <Styled.Copy as="span" size="small" lineHeight="dense" noMargin>
      {children}
    </Styled.Copy>
  </Styled.Container>
);
